import React from 'react';
import './Header.scss';

export default () => {
  return <header className="header"></header>
}
